<template>
  <section id="ajankohtaista" class="home-news" aria-labelledby="home-news-title">
    <div class="news-section-heading">
      <h2 id="home-news-title">Ajankohtaista</h2>
    </div>
    <div v-if="highlights.length" class="home-news-list">
      <NewsCard v-for="article in highlights" :key="article.slug" :article="article" :today="today" full heading-tag="h3" />
    </div>
    <p v-else class="news-empty-home">Ei uusia tiedotteita juuri nyt. Aiemmat kuulumiset löydät uutisista.</p>
    <div class="home-news-footer">
      <router-link to="/uutiset" class="news-read-link">Aiemmat uutiset <span aria-hidden="true">→</span></router-link>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue';
import NewsCard from './NewsCard.vue';
import { getHomeNews } from '../utils/news';
import { useNewsDate } from '../composables/useNewsDate';
const today = useNewsDate();
const highlights = computed(() => getHomeNews(today.value));
</script>
